import { render, staticRenderFns } from "./logorgselector.vue?vue&type=template&id=3da5dfd4"
import script from "./logorgselector.vue?vue&type=script&lang=js"
export * from "./logorgselector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports